import { useRef, useState } from "react";

// Lightweight bot defense shared by every lead form.
//
// 1. Honeypot: a visually-hidden decoy text input named "company". Humans
//    never see it (off-screen, aria-hidden, tabindex -1, skipped by
//    autofill via autocomplete="off"); form-filling bots typically fill
//    every field. The server silently drops any submission where it
//    arrives non-empty.
// 2. Timing: the hook records when the form was first rendered; submitLead
//    sends the render→submit elapsed time. The server silently drops
//    impossibly fast submissions (< ~2.5s).
//
// Both rejections return a normal-looking success response so bots never
// learn they were filtered. See server/index.js.

export function useBotDefense() {
  const [hp, setHp] = useState("");
  const renderedAtRef = useRef(Date.now());
  return {
    hp,
    setHp,
    get renderedAt() {
      return renderedAtRef.current;
    },
    // For forms that appear later than component mount (e.g. a modal that
    // is mounted app-wide but opens on demand): restart the timing clock.
    resetTimer() {
      renderedAtRef.current = Date.now();
    },
  };
}

export function HoneypotField({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: 1,
        height: 1,
        overflow: "hidden",
      }}
    >
      {/* Decoy — real users never see or fill this. The name is deliberately
          NON-semantic ("vy_extra_field") so browser/password-manager autofill
          never recognizes it and fills it on behalf of a real user (an
          autofillable name like "company" would silently kill real leads). */}
      <label>
        Leave this field empty
        <input
          type="text"
          name="vy_extra_field"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  );
}
